import { Dropdown } from 'flowbite-react';
import React from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { MyCompanyType } from 'types';

interface Props {
	company: MyCompanyType['company'];
	handleViewCompany: (comp: MyCompanyType['company']) => void;
	handleEditCompany: (companyId: string) => void;
	customStyleClass?: string;
}

const AMCompanyCardMoreOptions = ({ company, handleViewCompany, customStyleClass, handleEditCompany }: Props) => {
	return (
		<>
			<div
				className={`${customStyleClass}  [&_div[data-testid='flowbite-dropdown']]:!border-gray-200 dark:[&_div[data-testid='flowbite-dropdown']]:!border-gray-600 `}
			>
				<Dropdown
					inline={true}
					arrowIcon={false}
					color={'#C7C9D9'}
					className="!border-none dark:!bg-[#111E2C] !text-[#E4E4EB] w-[224px] rounded-[8px]"
					label={<BsThreeDotsVertical className="w-[24px] h-[24px]" />}
					dismissOnClick
				>
					<Dropdown.Item
						onClick={() => handleViewCompany(company)}
						className={
							'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
						}
					>
						View Details
					</Dropdown.Item>
					<Dropdown.Item
						disabled={company?.isBlacklisted}
						onClick={() => (!company?.isBlacklisted ? handleEditCompany(company._id) : false)}
						className={
							'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
						}
					>
						Edit Company Details
					</Dropdown.Item>
				</Dropdown>
			</div>
		</>
	);
};

export default AMCompanyCardMoreOptions;
